import { ClockIcon, UserIcon, HeartIcon as AB } from '@heroicons/react/24/outline';
import images from '../assets/images';
import { API_URL } from '../utils/urls';
import { convertNumberToWords, decode, encode, getCookie, keepTwoDecimals } from '../utils/helper';
import {
  canViewPhone,
  eqStr,
  giaPos,
  isAdmin,
  isBdsStatus,
  isHanche,
  isOldData,
  PERMISSION,
} from '../utils/permissions';
import { Button, Dialog, DialogHeader, DialogBody, Input } from '@material-tailwind/react';
import { useEffect, useRef, useState } from 'react';
import { ArrowDownTrayIcon, BellAlertIcon, HeartIcon, XMarkIcon } from '@heroicons/react/24/solid';
import { saveAs } from 'file-saver';
import JSZip from 'jszip';
import { checkPhoneChuDat, countThongKeViewSo, updateBds } from '../services/apiBds';
import { Link, useNavigate } from 'react-router-dom';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import { PhotoProvider, PhotoView } from 'react-photo-view';
import 'react-photo-view/dist/react-photo-view.css';
import SafeText, { SafeInline } from './SafeText';
import DialogBds from './DialogBds';
import { historysUser } from '../utils/history';
import { addYeuthich, removeYeuthich } from '../services/apiYeuthich';

const FrameShowBds = ({ data = {}, yeuthich = [], Avt = '', showImages = '', phuonggroup = '' }) => {
  const imageAvt = Avt ? Avt : images.banner_login;
  const auth = getCookie('token');
  const textRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [isSubModal, setIsSubModal] = useState(0);
  const [pass, setPass] = useState('');
  const [phoneChudat, setPhoneChudat] = useState([]);
  const [showImagess, setShowImagess] = useState([]);
  const [isPhoneChudat, setIsPhoneChudat] = useState('');
  const [isYeuThich, setIsYeuThich] = useState(yeuthich);
  const [isCopy, setIsCopy] = useState(0);
  const [giaCmt, setGiaCmt] = useState(0);
  const [isShow, setIsShow] = useState(0);
  const [discountCmt, setDiscountCmt] = useState('');
  const copyTimeoutRef = useRef(null);
  const gia = data?.bl?.length > 0 ? data?.bl?.filter((record) => parseInt(record?.gia) > 0) : [];
  const sdtchudat = data?.bl?.length > 0 ? data?.bl?.filter((record) => parseInt(record?.sdtchudat) > 0) : [];
  // const sdtchudatValues =
  //   sdtchudat?.length > 0
  //     ? sdtchudat.map((item) => ({
  //         create_date: item.create_date,
  //         sdtchudat: item.sdtchudat,
  //         sdtchudatvaitro: item.sdtchudatvaitro,
  //         username: item.username,
  //       }))
  //     : [];
  const divRef = useRef(null);
  const [objImageDetail, setObjImageDetail] = useState({ id: '', url: '' });
  const navigate = useNavigate();
  const handleOpen = () => {
    setOpen(!open);
    setPhoneChudat([]);
  };

  const fetchImages = async (imageNames) => {
    const res = await fetch(`${API_URL}/imgshop-batch?names=${imageNames}`);
    const data = await res.json();
    // console.log(showImagess);
    setShowImagess(data);
  };

  useEffect(() => {
    if (gia?.length > 0) {
      setGiaCmt(gia[0]['gia']);
      const discountPercentage = data['gia']
        ? parseInt(data['gia']) > gia[0]['gia']
          ? 'THẤP hơn ' + Math.round(((data['gia'] - gia[0]['gia']) / data['gia']) * 100) + '%'
          : 'TĂNG hơn ' + Math.round(((gia[0]['gia'] - data['gia']) / data['gia']) * 100) + '%'
        : '';
      setDiscountCmt(discountPercentage);
    }
  }, [gia, data]);

  useEffect(() => {
    return () => {
      if (copyTimeoutRef.current) clearTimeout(copyTimeoutRef.current);
    };
  }, []);

  const fetchIp = async () => {
    if (!auth) return;
    try {
      const response = await fetch('https://api.ipify.org?format=json');
      const data = await response.json();
      console.log(auth['wifi'], data.ip);
      if (response.status === 200) {
        if (auth['wifi'] !== data.ip && (Number(auth?.permission) === 2 || Number(auth?.permission) === 4)) {
          navigate('/dashboard', { replace: true });
        }
      } else {
        navigate('/dashboard', { replace: true });
      }
    } catch (err) {
      console.log(err);
    }
  };

  const typeImg = (str) => {
    const lastIndex = str.lastIndexOf('.');
    const result = str.substring(lastIndex + 1);
    if (result === 'png' || result === 'jpg' || result === 'jpeg') {
      return true;
    } else {
      return false;
    }
  };

  const handleCopyTextQHXD = async (data) => {
    let textToCopy = data;
    setIsCopy(data);
    navigator.clipboard
      .writeText(
        textToCopy
          .split('\n')
          .filter((line) => line.trim() !== '')
          .join('\n'),
      )
      .then(() => {
        if (copyTimeoutRef.current) clearTimeout(copyTimeoutRef.current);
        copyTimeoutRef.current = setTimeout(() => {
          setIsCopy(0);
          copyTimeoutRef.current = null;
        }, 1000);
      })
      .catch((error) => {
        console.error('Failed to copy text: ', error);
      });
  };

  const downloadImage = (imageURL, index, key) => {
    saveAs(imageURL, `${index + 1}_${Date.now()}`);
    historysUser({
      id_bds: data?.id,
      truong: key,
      noidung: '1',
    });
  };

  const downloadImagesAll = (arrImage) => {
    const imageUrls = arrImage.length > 0 ? arrImage : [];
    historysUser({
      id_bds: data?.id,
      truong: 'taihinh',
      noidung: imageUrls.length,
    });

    imageUrls.map((imageUrl, index) => {
      return fetch(`${imageUrl?.base64}`)
        .then((response) => response.blob())
        .then((blob) => {
          saveAs(blob, `${index + 1}_${Date.now()}`);
        });
    });
  };

  const downloadImagesAllSoTo = async (arrImage) => {
    const imageUrls = arrImage.length > 0 ? arrImage : [];
    if (imageUrls.length > 0) {
      const res = await fetch(`${API_URL}/imgshop-batch?names=${imageUrls}`);
      const dataImg = await res.json();
      historysUser({
        id_bds: data?.id,
        truong: 'taiso',
        noidung: imageUrls.length,
      });

      dataImg.map((item, index) => {
        return fetch(`${item?.base64}`)
          .then((response) => response.blob())
          .then((blob) => {
            saveAs(blob, `${index + 1}_${Date.now()}`);
          });
      });
    }
  };

  const downloadImagesAsZip = (arrImage, namezip, key) => {
    const imageUrls = arrImage?.split(',').length > 0 ? arrImage?.split(',') : [];
    historysUser({
      id_bds: data?.id,
      truong: key,
      noidung: imageUrls.length,
    });

    const zip = new JSZip();

    const promises = imageUrls.map((imageUrl, index) => {
      return fetch(`${API_URL}/imgshop?name=${imageUrl}`)
        .then((response) => response.blob())
        .then((blob) => {
          zip.file(imageUrl, blob);
        });
    });

    Promise.all(promises).then(() => {
      zip.generateAsync({ type: 'blob' }).then((content) => {
        saveAs(content, namezip + '.zip');
      });
    });
  };
  function parseVNDate(str) {
    if (!str || typeof str !== 'string') return new Date(0);
    const parts = str.split('T');
    if (parts.length < 2) return new Date(0);
    const dateParts = parts[0].split('/');
    if (dateParts.length < 3) return new Date(0);
    const [d, m, y] = dateParts.map(Number);
    if (isNaN(d) || isNaN(m) || isNaN(y)) return new Date(0);
    const timeParts = parts[1].split(':').map(Number);
    return new Date(y, m - 1, d, ...timeParts);
  }
  const checkInfoChuDat = async () => {
    const body = {
      user: auth.username,
      pass: pass,
      code: data.id,
    };
    const result = await checkPhoneChuDat(body);

    if (result.length > 0) {
      const arr = result[0]['sdtchudat']?.split(',') || [];
      const arrVaitro = result[0]['sdtchudatvaitro']?.split(',') || [];

      const dataBl = data?.bl
        // lọc các bản ghi có sdtchudat
        .filter((item) => item.sdtchudat && item.sdtchudat.trim() !== '')
        // lấy các field cần dùng
        .map((item) => ({
          is_user: item.is_user,
          username: item.username,
          create_date: item.create_date,
          sdtchudat: item.sdtchudat,
          sdtchudatvaitro: item.sdtchudatvaitro,
        }));

      const arrsdtchudatValues = arr.map((num, i) => ({
        create_date: data?.create_date,
        sdtchudat: num.trim(),
        sdtchudatvaitro: arrVaitro[i],
        username: data?.username,
        username: data?.is_user,
      }));
      // console.log(dataBl, arrsdtchudatValues);
      let arrPhoneDat = [...arrsdtchudatValues, ...dataBl]?.sort(
        (a, b) => parseVNDate(b.create_date) - parseVNDate(a.create_date),
      );
      setPass('');
      setPhoneChudat(arrPhoneDat);
      setIsPhoneChudat('');
      historysUser({
        id_bds: data?.id,
        truong: 'xemsdt',
        noidung: '1',
      });
    } else {
      setPhoneChudat([]);
      setIsPhoneChudat('Nhập mật khẩu sai. Vui lòng nhập lại');
    }
  };

  const checkTotalSo = async () => {
    fetchIp();
    const checkTotalSo = await countThongKeViewSo({
      data: { truong: 'xemso', username: auth?.username },
    });
    const perssion = auth?.s2;
    if (checkTotalSo?.totalRows < perssion) {
      handleOpen();
      setIsSubModal(2);
      historysUser({
        id_bds: data?.id,
        truong: 'xemso',
        noidung: '1',
      });
    } else {
      handleOpen();
      setIsSubModal(5);
    }
  };

  const checkTotalSoChu = async () => {
    fetchIp();
    const checkTotalSo = await countThongKeViewSo({
      data: { truong: 'xemsdt', username: auth?.username },
    });
    const perssion = auth?.s1;
    if (checkTotalSo?.totalRows < perssion) {
      handleOpen();
      setIsSubModal(3);
    } else {
      handleOpen();
      setIsSubModal(6);
    }
  };

  const subAddDefault = async () => {
    let arr = { id_user: auth?.id, id_bds: data?.id, status: 1 };
    let arradd = { id_user: auth?.id, id: data?.id, status: 1 };
    const resultAPI = await addYeuthich(arr);
    if (resultAPI.message === 'OK') {
      setIsYeuThich([...isYeuThich, arradd]);
    }
  };

  const alertRemove = async (id) => {
    const body = {
      id: id,
    };
    const resultAPI = await removeYeuthich(body);
    if (resultAPI.message === 'OK') {
      const arr = isYeuThich.filter((row) => {
        return row.id !== id;
      });
      setIsYeuThich([...arr]);
    }
  };

  const handleCopyText = (data) => {
    const textToCopy = `✨🏡✨ ${data.loaibds ? data?.loaibds : ''}${data.loaivitri ? ' - ' + data?.loaivitri : ''}${
      data.duong
        ? ' - đường ' + data?.duong + ', ' + data?.xa + (phuonggroup ? ` (${phuonggroup})` : '') + ', ' + data?.huyen
        : ''
    }${data.rongduong ? ', đường trước nhà ' + data?.rongduong + 'm' : ''}
    ${
      data?.dientich &&
      data?.dientich !== '0' &&
      data.dientichdatnn &&
      data.dientichdatnn !== null &&
      data.dientichdatnn !== '0'
        ? '\n👉 Diện tích: ' +
          keepTwoDecimals(parseFloat(data?.dientich) + parseFloat(data?.dientichdatnn)) +
          'm2' +
          ` (${data?.dientich && data?.dientich !== '0' ? data?.dientich + ' m2 thổ cư' : ''},${
            data?.dientichdatnn ? data?.dientichdatnn + ' m2 đất nông nghiệp' : ''
          } )`
        : ''
    }
    ${
      data?.dientich && (data.dientichdatnn === '0' || data.dientichdatnn === null || data.dientichdatnn === '')
        ? '\n👉 Diện tích: ' + data?.dientich + 'm2' + (data?.ngang ? ', ngang ' + data?.ngang + 'm' : '')
        : ''
    }
    ${
      data.sotang !== '0'
        ? '\n👉 Kết cấu: ' +
          (data?.sotang ? data?.sotang + ' tầng' : '') +
          (data.sophong !== '0'
            ? (data?.sophong ? ' - ' + data?.sophong + ' phòng' : '') + (data.sowc ? ' - ' + data?.sowc + ' WC' : '')
            : '')
        : ''
    }
    ${data?.quyhoach ? '\n👉 Quy hoạch: ' + data?.quyhoach : ''}
    ${data?.phaply ? '\n👉 Pháp lý: ' + data?.phaply : ''}
    ${
      data?.huongbds
        ? (() => {
            const huong = data.huongbds;

            if (huong.includes('Đông Tứ Trạch') || huong.includes('Tây Tứ Trạch') || huong.includes('Không Xác Định')) {
              return '\n👉 Hướng: ' + huong;
            }

            const arr = huong.split(',').map((i) => i.trim());

            const dongTuTrach = ['Đông', 'Đông Nam', 'Nam', 'Bắc'];
            const tayTuTrach = ['Tây', 'Tây Bắc', 'Tây Nam', 'Đông Bắc'];

            if (arr.some((h) => dongTuTrach.includes(h))) {
              return '\n👉 Hướng: ' + huong + ', Đông Tứ Trạch';
            }

            if (arr.some((h) => tayTuTrach.includes(h))) {
              return '\n👉 Hướng: ' + huong + ', Tây Tứ Trạch';
            }

            return '\n👉 Hướng: ' + huong;
          })()
        : ''
    }
    
    ${
      data?.dactrung || data?.tiennghi || data?.notekhach
        ? '\n👉 Mô tả: ' +
          (data?.tiennghi ? ' - ' + data?.tiennghi : '') +
          (data?.dactrung ? ' - ' + data?.dactrung : '') +
          (data?.notekhach ? ' - ' + data?.notekhach : '')
        : ''
    } 
    \n ${
      isBdsStatus(data.status, 2)
        ? 'Đã Bán'
        : isBdsStatus(data.status, 5)
          ? 'Ngưng bán'
          : isBdsStatus(data.status, 6)
            ? 'Không hề bán'
            : `👉 ${'Giá bán: ' + convertNumberToWords(data?.gia ? data?.gia : '')}
          `
    }
    ${data?.giathue ? '\n Giá thuê: ' + convertNumberToWords(data?.giathue) : ''}
    ${'\n Mã sản phẩm: #' + encode(data?.id)}`;

    setIsCopy(data?.id);

    navigator.clipboard
      .writeText(
        textToCopy
          .split('\n')
          .filter((line) => line.trim() !== '')
          .join('\n'),
      )
      .then(() => {
        if (copyTimeoutRef.current) clearTimeout(copyTimeoutRef.current);
        copyTimeoutRef.current = setTimeout(() => {
          setIsCopy(0);
          copyTimeoutRef.current = null;
        }, 1000);
      })
      .catch((error) => {
        console.error('Failed to copy text: ', error);
      });
  };

  const handleCopyTextSDT = (data) => {
    // console.log(data);
    const textToCopy = `✨🏡✨ ${data.loaibds ? data?.loaibds : ''}${data.loaivitri ? ' - ' + data?.loaivitri : ''}${
      data.duong
        ? ' - đường ' + data?.duong + ', ' + data?.xa + (phuonggroup ? ` (${phuonggroup})` : '') + ', ' + data?.huyen
        : ''
    } ${
      isBdsStatus(data.status, 2)
        ? ' (Đã Bán)'
        : isBdsStatus(data.status, 5)
          ? ' (Ngưng bán)'
          : isBdsStatus(data.status, 6)
            ? ' (Không hề bán)'
            : ` ${convertNumberToWords(data?.gia ? data?.gia : '')}
          `
    }
    ${data?.giathue ? '\n Giá thuê: ' + convertNumberToWords(data?.giathue) : ''}
    ${'#' + encode(data?.id)}
    ${
      data.soto &&
      data.soto?.split(',').length > 0 &&
      data.soto
        ?.split(',')
        .map(
          (row, i) =>
            `Sổ${data.soto?.split(',').length > 1 ? '#' + (i + 1) : ''}: Tờ: ${row} - Thửa: ${
              data.sothua?.split(',').length > 0 ? data.sothua?.split(',')[i] : ''
            } | ${data.xa},${data.huyen}`,
        )
    }
    ${'\n--------------------------------------'}
    ${phoneChudat.length > 0 ? '\n Thông tin Chủ - Nhập lúc ' + data.update_date : ''}
    ${phoneChudat.map(
      (row) =>
        row.sdtchudat &&
        '\n👉 ' +
          checkPhoneNumber(row.sdtchudat) +
          (row?.sdtchudatvaitro ? `(${row.sdtchudatvaitro})` : '') +
          ' Nhắn tin - Gọi Zalo(nếu có)',
    )}

    ${data?.notenoibo ? '\n👉 Ghi chú (nội bộ): \n- ' + data?.notenoibo : ''}

    ${data?.notekhach ? '\n --------------------------------------\n👉 Mô tả: \n-' + data?.notekhach : ''} `;

    setIsCopy(data?.id);

    navigator.clipboard
      .writeText(
        textToCopy
          .split('\n')
          .filter((line) => line.trim() !== '')
          .join('\n'),
      )
      .then(() => {
        if (copyTimeoutRef.current) clearTimeout(copyTimeoutRef.current);
        copyTimeoutRef.current = setTimeout(() => {
          setIsCopy(0);
          copyTimeoutRef.current = null;
        }, 1000);
      })
      .catch((error) => {
        console.error('Failed to copy text: ', error);
      });
  };

  const checkPhoneNumber = (text) => {
    const phoneNumberRegex = /\b\d{9,10}\b/g;
    const numbers = text.match(phoneNumberRegex);

    if (numbers) {
      const numberWithZero = numbers.map((number) => {
        if (number.length === 9) {
          return '0' + number;
        } else {
          return number;
        }
      });

      return numberWithZero.join(', ');
    } else {
      return text;
    }
  };

  const isPostExpired = (createDate) => {
    if (!createDate || typeof createDate !== 'string') return true;
    const parts = createDate.split('T');
    if (parts.length < 2) return true;
    const dateParts = parts[0].split('/');
    if (dateParts.length < 3) return true;
    const [dd, mm, yy] = dateParts;
    if (isNaN(Number(dd)) || isNaN(Number(mm)) || isNaN(Number(yy))) return true;
    const formattedDate = `${yy}-${mm.padStart(2, '0')}-${dd.padStart(2, '0')}T${parts[1]}`;

    const postTime = new Date(formattedDate).getTime();
    if (isNaN(postTime)) return true;

    const currentTime = new Date().getTime();
    const diffMinutes = (currentTime - postTime) / (1000 * 60);
    return diffMinutes > 30;
  };

  const alertRemoveBV = async (id) => {
    if (window.confirm(`Bạn muốn cho tin này vào THÙNG RÁC`)) {
      // Save it!
      const formData = new FormData();
      const body = { id: id, status: '4' };
      formData.append('data', JSON.stringify(body));
      const resultAPISIM = await updateBds(formData);
      if (resultAPISIM?.message === 'OK') {
        setIsShow(1);
      }
    } else {
      // Do nothing!
      setIsShow(0);
      console.log('Hủy yêu cầu');
    }
  };

  return (
    <>
      {' '}
      {isShow === 0 && (
        <div>
          <Dialog open={open} handler={handleOpen} size="lg">
            <div className="flex justify-end -mt-[15px] -mr-[15px]">
              {' '}
              <Button onClick={handleOpen} variant="filled" color="orange" size="sm" className="rounded-xl">
                <XMarkIcon className="h-5 w-5" />
              </Button>
            </div>
            <DialogHeader className="font-[UTM-Avo] justify-center p-1">
              {(isSubModal === 1 || isSubModal === 2 || isSubModal === 7) && (
                <div className="text-xl text-center">
                  MS #{encode(data?.id)} -{' '}
                  {`${data.loaibds && data?.loaibds}${data.loaivitri && ' - ' + data?.loaivitri}${
                    data.duong &&
                    ' - đường ' +
                      data?.duong +
                      ', ' +
                      data?.xa +
                      (phuonggroup ? ` (${phuonggroup})` : '') +
                      ', ' +
                      data?.huyen
                  }`}
                </div>
              )}
              {isSubModal === 3 && (
                <div className="text-lg">
                  <b className="text-orange-800">
                    MS #{encode(data?.id)}
                    {(data?.dientich && data.dientichdatnn && data.dientichdatnn !== null && data.dientichdatnn !== '0'
                      ? ' - ' +
                        keepTwoDecimals(parseFloat(data?.dientich) + parseFloat(data?.dientichdatnn)) +
                        'm2' +
                        ` (${data?.dientich && data?.dientich !== '0' ? data?.dientich + ' m2 thổ cư' : ''},${
                          data?.dientichdatnn ? data?.dientichdatnn + ' m2 đất nông nghiệp' : ''
                        } )`
                      : '') +
                      (data?.dientich &&
                      (data.dientichdatnn === '0' || data.dientichdatnn === null || data.dientichdatnn === '')
                        ? ' - ' + data?.dientich + 'm2' + (data?.ngang ? ' - ngang ' + data?.ngang + 'm' : '')
                        : '')}{' '}
                    {isBdsStatus(data.status, 2) ? (
                      ' - Đã Bán'
                    ) : isBdsStatus(data.status, 5) ? (
                      ' - Ngưng bán'
                    ) : isBdsStatus(data.status, 6) ? (
                      ' - Không hề bán'
                    ) : (
                      <b>
                        {giaCmt > 0
                          ? ' - ' + convertNumberToWords(giaCmt)
                          : ' - ' + convertNumberToWords(data?.gia ? data?.gia : '')}
                        <b className="font-bold text-teal-800">
                          {' '}
                          {data?.giathue > 0 && ' - Giá thuê: ' + convertNumberToWords(data?.giathue)}{' '}
                        </b>
                      </b>
                    )}{' '}
                    {data.sotang !== '0'
                      ? (data?.sotang ? ' - ' + data?.sotang + ' tầng' : '') +
                        (data.sophong !== '0'
                          ? (data?.sophong ? ' - ' + data?.sophong + ' phòng' : '') +
                            (data.sowc ? ' - ' + data?.sowc + ' WC' : '')
                          : '')
                      : ''}{' '}
                    {`${data.loaibds ? ' - ' + data?.loaibds : ''}${data.loaivitri ? ' - ' + data?.loaivitri : ''} ${
                      data.duong &&
                      ' - đường ' +
                        data?.duong +
                        ', ' +
                        data?.xa +
                        (phuonggroup ? ` (${phuonggroup})` : '') +
                        ', ' +
                        data?.huyen
                    } `}
                  </b>{' '}
                  <br />
                  <span className={`${isOldData(data.is_user) ? 'text-gray-500' : ''}`}>
                    Người nhập:{' '}
                    {isOldData(data.is_user)
                      ? 'OLD DATA - LH: 0869596979 - Nguyễn Thị Ngọc Bích - 47 Lý Nam Đế'
                      : `${data.name}  - ${data.username}
                    ${phoneChudat.length > 0 && data.phone ? '- LH: ' + data.phone : ''}
                    ${' - 47 lý nam đế'} ${data?.nameteam ? ' - ' + data?.nameteam : ''}
                    ${
                      data?.fteam === '1' ? ' - F1' : data?.fteam === '2' ? ' - F2' : data?.fteam === '3' ? ' - F3' : ''
                    }`}
                  </span>
                </div>
              )}
            </DialogHeader>
            <hr className="my-2 border-blue-gray-50" />
            <DialogBody
              className={
                isSubModal === 3 || isSubModal === 2 || isSubModal === 5 || isSubModal === 6
                  ? 'overflow-scroll'
                  : 'h-[40rem] overflow-scroll'
              }
            >
              <div className="flex flex-col justify-center">
                {isSubModal === 1 && (
                  <div>
                    <div className="grid justify-center mb-6">
                      <Link to={`/bds/${encode(data.id)}`} target="_blank">
                        <div className="text-light-blue-700 hover:underline cursor-pointer">
                          [Bình luận & xem chi tiết]
                        </div>
                      </Link>
                      <div className="flex justify-center">
                        <div>
                          {auth?.s4 == '0' && (
                            <span
                              className="text-xs text-center text-black bg-orange-400 rounded-md p-2 font-bold mx-1 cursor-pointer hover:bg-green-300"
                              onClick={checkTotalSo}
                            >
                              Sổ
                            </span>
                          )}
                          {canViewPhone(auth, data, giaCmt) ? (
                            <span
                              className="text-xs text-center bg-orange-400 rounded-md p-1 font-bold mx-1 cursor-pointer hover:bg-green-300"
                              onClick={checkTotalSoChu}
                            >
                              Xem SĐT
                            </span>
                          ) : (
                            ''
                          )}
                          {/* <span
                            className="bg-orange-400 text-black rounded-md p-2 whitespace-nowrap text-xs font-bold mx-1 cursor-pointer hover:bg-green-300"
                            onClick={() => setIsSubModal(3)}
                          >
                            Xem SĐT
                          </span> */}
                        </div>
                      </div>
                    </div>
                    <hr className="my-2 border-blue-gray-50" />
                    <PhotoProvider
                      className="!z-[9999]"
                      onIndexChange={(i) => {
                        setObjImageDetail({
                          id: i,
                          url: showImagess && showImagess.length > 0 ? `${showImagess[i]['base64']}` : '',
                        });
                      }}
                      toolbarRender={({ rotate, onRotate, scale, onScale }) => (
                        <div className="flex gap-3 mt-2 p-2 rounded shadow-lg ">
                          <Button onClick={() => onRotate(rotate + 90)} color="blue" size="sm">
                            Xoay
                          </Button>
                          <Button onClick={() => onScale(scale + 0.2)} color="amber" size="sm">
                            Phóng to
                          </Button>
                          <Button onClick={() => onScale(scale - 0.2)} color="yellow" size="sm">
                            Thu nhỏ
                          </Button>
                          <Button
                            color="green"
                            size="sm"
                            onClick={() => downloadImage(objImageDetail.url, objImageDetail.id)}
                          >
                            Tải về
                          </Button>
                        </div>
                      )}
                    >
                      <div className="grid grid-cols-3 lg:grid-cols-5 gap-2">
                        {showImagess &&
                          showImagess.length > 0 &&
                          showImagess.map((imageSrc, i) => (
                            <figure className="relative w-full" key={i}>
                              <PhotoView src={`${imageSrc?.base64}`}>
                                <LazyLoadImage
                                  alt={'không có ảnh'}
                                  width={'100%'}
                                  effect="blur"
                                  src={`${imageSrc?.base64}`}
                                  className=" border hover:border-amber-500 hover:border-dashed p-1 rounded-2xl cursor-pointer"
                                  onClick={() => {
                                    setObjImageDetail({ id: i, url: `${imageSrc?.base64}` });
                                  }}
                                />
                              </PhotoView>

                              <figcaption className="absolute top-[5px] left-[29px] flex px-1 -translate-x-2/4 justify-center border border-white bg-white text-white shadow-lg shadow-black/5 saturate-200 backdrop-blur-sm rounded-lg">
                                <div
                                  className="flex items-center cursor-pointer"
                                  onClick={() => downloadImage(`${imageSrc?.base64}`, i, 'taihinh')}
                                >
                                  <ArrowDownTrayIcon className="w-5 h-5 text-orange-600" />
                                  <span className="text-orange-600 text-xs ml-1"> #{i + 1}</span>
                                </div>
                              </figcaption>
                            </figure>
                          ))}
                      </div>
                    </PhotoProvider>
                    {showImagess && (
                      <div className="flex justify-center">
                        <div
                          className="flex items-center cursor-pointer p-2 bg-orange-500 text-gray-900 font-bold rounded-xl hover:bg-green-300"
                          onClick={() => downloadImagesAll(showImagess)}
                        >
                          <ArrowDownTrayIcon className="w-5 h-5" />
                          <span className="ml-1">Tải về tất cả</span>
                        </div>
                      </div>
                    )}
                  </div>
                )}

                {isSubModal === 2 && (
                  <div>
                    <div className="grid justify-center mb-5">
                      {data.soto &&
                        data.soto?.split(',').length > 0 &&
                        data.soto?.split(',').map((row, i) => (
                          <div key={i} className="text-black">
                            {`Sổ#${i + 1}: `} <span className="font-bold">Tờ:</span> {row} |{' '}
                            <span className="font-bold">Thửa:</span>{' '}
                            {data.sothua?.split(',').length > 0 ? data.sothua?.split(',')[i] : ''} |{' '}
                            <span>
                              {data.xa},{data.huyen}
                            </span>
                          </div>
                        ))}
                    </div>
                    <PhotoProvider
                      className="!z-[9999]"
                      onIndexChange={(i) => {
                        setObjImageDetail({
                          id: i,
                          url:
                            data.anhthua && data.anhthua?.split(',').length > 0
                              ? `${API_URL}/imgshop?name=${data.anhthua?.split(',')[i]}`
                              : '',
                        });
                      }}
                      toolbarRender={({ rotate, onRotate, scale, onScale }) => (
                        <div className="flex gap-3 mt-2 p-2 rounded shadow-lg ">
                          <Button onClick={() => onRotate(rotate + 90)} color="blue" size="sm">
                            Xoay
                          </Button>
                          <Button onClick={() => onScale(scale + 0.2)} color="amber" size="sm">
                            Phóng to
                          </Button>
                          <Button onClick={() => onScale(scale - 0.2)} color="yellow" size="sm">
                            Thu nhỏ
                          </Button>
                          <Button
                            color="green"
                            size="sm"
                            onClick={() => downloadImage(objImageDetail.url, objImageDetail.id)}
                          >
                            Tải về
                          </Button>
                        </div>
                      )}
                    >
                      <div className="grid grid-cols-3 lg:grid-cols-5 gap-2">
                        {data.anhthua &&
                          data.anhthua?.split(',').length > 0 &&
                          data.anhthua?.split(',').map((imageSrc, i) => (
                            <figure className="relative w-full" key={i}>
                              {typeImg(imageSrc) ? (
                                <div className="bg-white border rounded-lg cursor-pointer">
                                  <PhotoView src={`${API_URL}/imgshop?name=${imageSrc}`}>
                                    <LazyLoadImage
                                      alt={'không có ảnh'}
                                      width={'100%'}
                                      effect="blur"
                                      src={`${API_URL}/imgshop?name=${imageSrc}`}
                                      className=" border hover:border-amber-500 hover:border-dashed p-1 rounded-2xl cursor-pointer"
                                      onClick={() => {
                                        setObjImageDetail({ id: i, url: `${API_URL}/imgshop?name=${imageSrc}` });
                                      }}
                                    />
                                  </PhotoView>
                                </div>
                              ) : (
                                <div className="w-full h-full border rounded-xl flex justify-center items-center">
                                  <a
                                    href={`${API_URL}/imgshop?name=${imageSrc}`}
                                    download={imageSrc}
                                    className=" border hover:border-amber-500 hover:border-dashed p-1 rounded-xl"
                                  >
                                    {'file_' + (i + 1)}
                                  </a>
                                </div>
                              )}
                              <figcaption className="absolute top-[5px] left-[29px] flex px-1 -translate-x-2/4 justify-center border border-white bg-white text-white shadow-lg shadow-black/5 saturate-200 backdrop-blur-sm rounded-lg">
                                <div
                                  className="flex items-center cursor-pointer"
                                  onClick={() => downloadImage(`${API_URL}/imgshop?name=${imageSrc}`, i, 'taiso')}
                                >
                                  <ArrowDownTrayIcon className="w-5 h-5 text-orange-600" />
                                  <span className="text-orange-600 text-xs ml-1"> #{i + 1}</span>
                                </div>
                              </figcaption>
                            </figure>
                          ))}
                      </div>
                    </PhotoProvider>
                    {data.anhthua && (
                      <div className="flex justify-center mt-3">
                        <div
                          className="flex items-center cursor-pointer p-2 bg-orange-500 text-gray-900 font-bold rounded-xl hover:bg-green-300"
                          onClick={() => downloadImagesAllSoTo(data.anhthua)}
                        >
                          <ArrowDownTrayIcon className="w-5 h-5" />
                          <span className="ml-1">Tải về tất cả</span>
                        </div>
                      </div>
                    )}
                    <hr className="my-2 border-blue-gray-50" />
                    <div className="grid justify-center mb-6">
                      <Link to={`/bds/${encode(data.id)}`} target="_blank">
                        <div className="text-light-blue-700 hover:underline cursor-pointer">
                          [Bình luận & xem chi tiết]
                        </div>
                      </Link>
                      <div className="flex justify-center">
                        <div>
                          <span
                            className="text-xs text-center text-black bg-orange-400 rounded-md p-2 font-bold mx-1 cursor-pointer hover:bg-green-300"
                            onClick={() => {
                              setIsSubModal(1);
                              fetchImages(showImages && showImages.join(','));
                            }}
                          >
                            Hình
                          </span>
                          {/* <span
                            className="bg-orange-400 text-black rounded-md p-2 whitespace-nowrap text-xs font-bold mx-1 cursor-pointer hover:bg-green-300"
                            onClick={() => setIsSubModal(3)}
                          >
                            Xem SĐT
                          </span> */}
                          {canViewPhone(auth, data, giaCmt) ? (
                            <span
                              className="text-xs text-center bg-orange-400 rounded-md p-1 font-bold mx-1 cursor-pointer hover:bg-green-300"
                              onClick={checkTotalSoChu}
                            >
                              Xem SĐT
                            </span>
                          ) : (
                            ''
                          )}
                        </div>
                      </div>
                    </div>
                    <hr className="my-2 border-blue-gray-50" />
                  </div>
                )}

                {isSubModal === 3 && (
                  <div>
                    {phoneChudat.length === 0 && isPostExpired(data?.create_date) && (
                      <div>
                        <div className="text-xl text-black font-bold mb-5">
                          Nhập mật khẩu để xem thông tin chủ BĐS #{encode(data?.id)}
                        </div>
                        <label className="flex items-end gap-1 text-sm mb-1">
                          <b> Nhập Mật khẩu của tài khoản {auth.username}</b>
                        </label>

                        <Input
                          type="password"
                          className="!border !border-gray-400 bg-white text-gray-900 ring-4 ring-transparent placeholder:text-gray-500 placeholder:opacity-100"
                          labelProps={{
                            className: 'hidden',
                          }}
                          containerProps={{
                            className: 'min-w-[0px!important]',
                          }}
                          onChange={(e) => {
                            setPass(e.target.value);
                          }}
                        />
                        <Button color="orange" size="sm" className="rounded-full mt-4" onClick={checkInfoChuDat}>
                          Xem thông tin
                        </Button>
                      </div>
                    )}
                    {phoneChudat.length === 0 && !isPostExpired(data?.create_date) && (
                      <b className="text-red-500">Hệ thống sẽ hiển thị sau 30 phút kể từ lúc tạo bài viết</b>
                    )}
                    {phoneChudat.length > 0 && isPostExpired(data?.create_date) ? (
                      <div className="grid justify-center">
                        <div className="text-xl text-center text-black mb-3">
                          <span className="font-bold font-[UTM-Avo]">Thông tin chủ BĐS #{encode(data?.id)}</span>
                        </div>

                        {phoneChudat.map(
                          (row, i) =>
                            row && (
                              <div key={i} className="text-black flex flex-wrap gap-2 mb-1 border-b pb-1">
                                {`Sđt #${i + 1}: `}{' '}
                                <span className="font-bold">
                                  {row.sdtchudat}{' '}
                                  <span className="font-light italic">
                                    {row?.sdtchudatvaitro ? `(${row?.sdtchudatvaitro})` : ''}
                                  </span>
                                </span>{' '}
                                <span className={`${isOldData(row.is_user) ? 'text-gray-500' : ''}`}>
                                  {' '}
                                  - Người nhập: {isOldData(row.is_user) ? 'old_data' : row.username}
                                </span>{' '}
                                <span> - Ngày: {row.create_date}</span>
                                <a href={`https://zalo.me/${checkPhoneNumber(row.sdtchudat)}`} target="_blank">
                                  <img src={images.zalo} alt="alt" width={'30px'} height={'30px'} />
                                </a>
                              </div>
                            ),
                        )}

                        {isHanche(data?.ishanche, 1) && (
                          <div>
                            <span className="text-red-500 font-bold">
                              Lưu ý: Cần việc quan trọng mới gọi chủ đất - hạn chế gọi nhiều{' '}
                            </span>
                          </div>
                        )}

                        <br />
                        {data.notenoibo && (
                          <span className="text-sm">
                            ⚫️ Ghi chú nội bộ:
                            {data.notenoibo}
                          </span>
                        )}
                      </div>
                    ) : (
                      ''
                    )}
                    {phoneChudat.length > 0 && (
                      <div>
                        <hr className="my-2 border-blue-gray-50" />

                        <div className="grid justify-center mb-6">
                          <Link to={`/bds/${encode(data.id)}`} target="_blank">
                            <div className="text-light-blue-700 hover:underline cursor-pointer">
                              [Bình luận & xem chi tiết]
                            </div>
                          </Link>
                          <div className="flex justify-center">
                            <div>
                              <span
                                className="text-xs text-center text-black bg-orange-400 rounded-md p-2 font-bold mx-1 cursor-pointer hover:bg-green-300"
                                onClick={() => {
                                  setIsSubModal(1);
                                  fetchImages(showImages && showImages.join(','));
                                }}
                              >
                                Hình
                              </span>
                              {auth?.s4 == '0' && (
                                <span
                                  className="text-xs text-center text-black bg-orange-400 rounded-md p-2 font-bold mx-1 cursor-pointer hover:bg-green-300"
                                  onClick={checkTotalSo}
                                >
                                  Sổ
                                </span>
                              )}
                              <span
                                className={`${
                                  isCopy === data?.id ? 'bg-green-400' : 'bg-orange-400'
                                } text-xs text-center text-black bg-orange-400 rounded-md p-2 font-bold mx-1 cursor-pointer hover:bg-green-300`}
                                onClick={() => {
                                  handleCopyTextSDT(data);
                                }}
                              >
                                {isCopy === data?.id ? 'Đã copy!' : 'Copy'}
                              </span>
                            </div>
                          </div>
                        </div>
                        <hr className="my-2 border-blue-gray-50" />
                      </div>
                    )}
                    <div>{isPhoneChudat ? <b className="text-red-500">{isPhoneChudat}</b> : ''}</div>
                  </div>
                )}

                {isSubModal === 4 && (
                  <div>
                    <div className="grid grid-cols-3 lg:grid-cols-6 gap-2 mt-5 ">
                      {showImagess.length > 0 &&
                        showImagess.map((imageSrc, i) => (
                          <figure className="relative w-full" key={i}>
                            <img
                              src={`${imageSrc?.base64}`}
                              alt="not fount"
                              width={'100%'}
                              className=" border hover:border-amber-500 hover:border-dashed p-1 rounded-2xl"
                              loading="lazy"
                            />
                            <figcaption className="absolute top-[5px] left-[29px] flex px-1 -translate-x-2/4 justify-center border border-white bg-white text-white shadow-lg shadow-black/5 saturate-200 backdrop-blur-sm rounded-lg">
                              <div
                                className="flex items-center cursor-pointer"
                                onClick={() => downloadImage(`${imageSrc?.base64}`, i)}
                              >
                                <ArrowDownTrayIcon className="w-5 h-5 text-orange-600" />
                                <span className="text-orange-600 text-xs ml-1"> #{i + 1}</span>
                              </div>
                            </figcaption>
                          </figure>
                        ))}
                    </div>
                    {showImagess.length > 0 && (
                      <div className="flex justify-center">
                        <div
                          className="flex items-center cursor-pointer p-2 bg-orange-500 text-gray-900 font-bold rounded-xl hover:bg-green-300"
                          onClick={() => downloadImagesAll(showImagess)}
                        >
                          <ArrowDownTrayIcon className="w-5 h-5" />
                          <span className="ml-1">Tải về tất cả</span>
                        </div>
                      </div>
                    )}

                    <div className="mt-4 leading-7 text-black">
                      {/* <p className="font-bold">{data?.tieude}</p> */}
                      <div className=" font-sans">
                        {(data?.sotang !== '0' ? (data?.sotang ? '👉 ' + data?.sotang + ' tầng' : '') : '') +
                          (data.sotang !== '0'
                            ? (data?.ngang ? ' - ngang ' + data?.ngang + 'm' : '') +
                              (data?.nganghau ? `(ngang hậu ${data?.nganghau}m)` : '')
                            : data?.ngang
                              ? (data?.ngang ? '👉 ngang' + data?.ngang + 'm' : '') +
                                (data?.nganghau ? `(ngang hậu ${data?.nganghau}m)` : '')
                              : '') +
                          (data.sophong !== '0' ? (data?.sophong ? '👉 ' + data?.sophong + ' phòng' : '') : '') +
                          (data.sowc ? ' - ' + data?.sowc + ' WC' : '') +
                          (data.dientich && data.dai
                            ? ` - ${data.ngang ? data.ngang + 'm x' : ''} ${data.dai ? data.dai + 'm' : ''} - ${
                                data.dientich
                              }m2`
                            : '') +
                          (data?.dientich &&
                          data.dientichdatnn &&
                          data.dientichdatnn !== null &&
                          data.dientichdatnn !== '0'
                            ? '\n👉 Diện tích: ' +
                              keepTwoDecimals(parseFloat(data?.dientich) + parseFloat(data?.dientichdatnn)) +
                              'm2' +
                              ` (${data?.dientich && data?.dientich !== '0' ? data?.dientich + ' m2 thổ cư' : ''},${
                                data?.dientichdatnn ? data?.dientichdatnn + ' m2 đất nông nghiệp' : ''
                              } )`
                            : '') +
                          (data?.dientich &&
                          (data.dientichdatnn === '0' || data.dientichdatnn === null || data.dientichdatnn === '')
                            ? '\n👉 Diện tích: ' +
                              data?.dientich +
                              'm2' +
                              (data?.ngang ? ', ngang ' + data?.ngang + 'm' : '')
                            : '') +
                          (data.dientichsan ? ' - tổng diện tích sàn ' + data?.dientichsan + 'm2' : '') +
                          (data?.huongbds
                            ? (() => {
                                const huong = data.huongbds;

                                if (
                                  huong.includes('Đông Tứ Trạch') ||
                                  huong.includes('Tây Tứ Trạch') ||
                                  huong.includes('Không Xác Định')
                                ) {
                                  return ' - hướng ' + huong;
                                }

                                const arr = huong.split(',').map((i) => i.trim());

                                const dongTuTrach = ['Đông', 'Đông Nam', 'Nam', 'Bắc'];
                                const tayTuTrach = ['Tây', 'Tây Bắc', 'Tây Nam', 'Đông Bắc'];

                                if (arr.some((h) => dongTuTrach.includes(h))) {
                                  return ' - hướng ' + huong + ', Đông Tứ Trạch';
                                }

                                if (arr.some((h) => tayTuTrach.includes(h))) {
                                  return ' - hướng ' + huong + ', Tây Tứ Trạch';
                                }

                                return ' - hướng ' + huong;
                              })()
                            : '') +
                          (data.tiennghi ? ' - ' + data?.tiennghi : '') +
                          (data.dactrung ? ' - ' + data?.dactrung : '') +
                          (data.quyhoach ? ' - Quy hoạch ' + data?.quyhoach : '')}
                      </div>
                      <SafeText className="font-sans" text={data?.notekhach} />

                      <div className="mt-5">
                        {isBdsStatus(data.status, 2) ? (
                          <p className="font-bold text-red-700 font-sans ml-1">
                            Đã Bán -{' '}
                            {giaCmt > 0
                              ? convertNumberToWords(giaCmt)
                              : convertNumberToWords(data?.gia ? data?.gia : '')}
                          </p>
                        ) : isBdsStatus(data.status, 5) ? (
                          <p className="font-bold text-red-700 font-sans ml-1">Ngưng bán</p>
                        ) : isBdsStatus(data.status, 6) ? (
                          <p className="font-bold text-red-700 font-sans ml-1">Không hề bán</p>
                        ) : (
                          <p className="font-bold text-green-700 font-sans ml-1">
                            {giaCmt > 0
                              ? convertNumberToWords(giaCmt)
                              : convertNumberToWords(data?.gia ? data?.gia : '')}
                            {giaCmt > 0
                              ? data?.dientich || data?.dientichdatnn
                                ? `- ${convertNumberToWords(
                                    parseInt(giaCmt) /
                                      (parseInt(data?.dientich || 1) + parseInt(data?.dientichdatnn || 0)),
                                  )}/m2`
                                : ''
                              : data?.gia && (data?.dientich || data?.dientichdatnn)
                                ? `- ${convertNumberToWords(
                                    parseInt(data?.gia) /
                                      (parseInt(data?.dientich || 1) + parseInt(data?.dientichdatnn || 0)),
                                  )}/m2`
                                : ''}
                            <span className="font-light text-gray-900">
                              {giaCmt > 0 && data?.gia
                                ? parseInt(data?.gia) > parseInt(giaCmt)
                                  ? ` (đã giảm ${convertNumberToWords(parseInt(data?.gia) - parseInt(giaCmt))})`
                                  : ` (đã tăng ${convertNumberToWords(parseInt(giaCmt) - parseInt(data?.gia))})`
                                : ''}{' '}
                            </span>
                            <br />
                            <span className="font-bold text-teal-800">
                              {' '}
                              {data?.giathue > 0 && 'Giá thuê: ' + convertNumberToWords(data?.giathue)}{' '}
                            </span>
                            <span className="font-thin text-black">- MS: #{encode(data?.id)} </span>
                          </p>
                        )}
                        <p className="font-bold text-green-700">| {discountCmt}</p>
                        <Link
                          to={`/bang-gia-m2?lbs=${data?.loaibds}&lvt=${data?.loaivitri}&d=${data?.duong}&h=${data?.huyen}&gia=${data?.gia}&dt=${data?.dientich}`}
                          target="_blank"
                        >
                          <p className="text-blue-800 hover:underline hover:text-blue-500 cursor-pointer font-sans">
                            {data?.tlq?.totalRow > 0
                              ? `| ${convertNumberToWords(parseInt(data?.tlq?.price) / parseInt(data?.tlq?.dt))}/m2 (${
                                  data?.tlq?.totalRow
                                } bđs)`
                              : ''}
                          </p>
                        </Link>
                      </div>
                    </div>
                    {data?.bl?.length > 0 && (
                      <div>
                        <hr className="my-2 border-blue-gray-50" />

                        {data?.bl?.map((row, i) => (
                          <p key={i} className={`flex items-center mb-2 pt-1 ${i !== 0 ? 'border-t' : ''}`}>
                            <span className="flex items-center text-sm text-gray-900">
                              <UserIcon className="w-4 h-4 mr-1" />{' '}
                              <label className={`${isOldData(row?.is_user) ? 'text-gray-400' : ''}`}>
                                {isOldData(row?.is_user) ? 'Old Data' : row?.username}
                              </label>
                              <ClockIcon className="w-4 h-4 ml-1 mr-1" /> {row?.update_date?.split('T')[1]} -{' '}
                              {row?.update_date?.split('T')[0]}:
                            </span>
                            <span className="ml-4 text-sm  text-gray-900">
                              {giaPos(row?.gia)
                                ? parseInt(data?.gia) > parseInt(row?.gia)
                                  ? ` đã GIẢM ${convertNumberToWords(parseInt(data?.gia))} còn ${convertNumberToWords(
                                      row?.gia,
                                    )}`
                                  : ` đã TĂNG ${convertNumberToWords(parseInt(data?.gia))} lên ${convertNumberToWords(
                                      row?.gia,
                                    )}`
                                : ''}
                              {row?.noidung ? ' - ' + row?.noidung : ''}
                              {row?.sdtchudat ? ' - đã thêm số chủ đất' : ''}
                              {row?.anh ? ' - đã thêm ảnh' : ''}
                              {row?.anhso ? ' - đã thêm ảnh sổ' : ''}
                              {row?.qhxd ? ' - Đã cập nhật quy hoạch XD ' : ''}
                              {row?.nhaclich
                                ? ' - đã nhắc nhở ' + new Date(row?.nhaclich).toLocaleDateString() + ' hết hạn bán'
                                : ''}
                            </span>
                          </p>
                        ))}
                      </div>
                    )}
                    <hr className="my-2 border-blue-gray-50" />
                    <div>
                      {data?.notenoibo && <span className="text-black">👉 Ghi chú (nội bộ): {data?.notenoibo}</span>}
                    </div>
                    <div className="flex mt-2">
                      <DialogBds data={data} showImages={data.anhto} />
                    </div>
                    <hr className="my-2 border-blue-gray-50" />
                    <div className="mt-10 text-center">
                      <b>
                        👉 Nhập bởi:{' '}
                        <b className={`${isOldData(data.is_user) ? 'text-gray-500' : ''}`}>
                          {isOldData(data.is_user)
                            ? 'OLD DATA - LH: 0869596979 - Nguyễn Thị Ngọc Bích - 47 Lý Nam Đế'
                            : `${data.name} - ${data.username} - ${data.address}`}
                        </b>
                      </b>
                    </div>
                  </div>
                )}

                {isSubModal === 5 && (
                  <div className="grid justify-items-center  items-center">
                    <BellAlertIcon className="h-20 w-20 text-red-400" />
                    <span className="font-bold text-red-400">
                      BẠN ĐÃ HẾT SỐ LƯỢNG XEM SỔ MỚI TRONG NGÀY {auth?.s2}/{auth?.s2}
                    </span>
                  </div>
                )}

                {isSubModal === 6 && (
                  <div className="grid justify-items-center  items-center">
                    <BellAlertIcon className="h-20 w-20 text-red-400" />
                    <span className="font-bold text-red-400">
                      BẠN ĐÃ HẾT SỐ LƯỢNG XEM SỐ CHỦ MỚI TRONG NGÀY {auth?.s1}/{auth?.s1}
                    </span>
                  </div>
                )}

                {isSubModal === 7 && data?.bl?.length > 0 && (
                  <div>
                    {data?.bl?.map((row, i) => (
                      <div key={i}>
                        {row?.qhxd && (
                          <p className={` mb-2 pt-1 ${i !== 0 ? 'border-t' : ''} text-black`}>
                            <div className="flex items-center text-sm">
                              <UserIcon className="w-4 h-4 mr-1" />{' '}
                              <label className={`${isOldData(row?.is_user) ? 'text-gray-400' : ''}`}>
                                {isOldData(row?.is_user) ? 'Old Data' : row?.username}
                              </label>
                              <ClockIcon className="w-4 h-4 ml-1 mr-1" /> {row?.update_date?.split('T')[1]} -{' '}
                              {row?.update_date?.split('T')[0]}:
                            </div>
                            <div className="font-sans border p-2 rounded mt-1">
                              <SafeText className="font-sans" text={row?.qhxd} />

                              <Button color="orange" size="sm" onClick={() => handleCopyTextQHXD(row.qhxd)}>
                                {isCopy === row.qhxd ? 'Đã Copy!' : 'Copy'}
                              </Button>
                            </div>
                          </p>
                        )}

                        <PhotoProvider
                          className="!z-[9999]"
                          onIndexChange={(i) => {
                            setObjImageDetail({
                              id: i,
                              url:
                                row.anh_qhxd && row.anh_qhxd?.split(',').length > 0
                                  ? `${API_URL}/imgshop?name=${row.anh_qhxd?.split(',')[i]}`
                                  : '',
                            });
                          }}
                          toolbarRender={({ rotate, onRotate, scale, onScale }) => (
                            <div className="flex gap-3 mt-2 p-2 rounded shadow-lg ">
                              <Button onClick={() => onRotate(rotate + 90)} color="blue" size="sm">
                                Xoay
                              </Button>
                              <Button onClick={() => onScale(scale + 0.2)} color="amber" size="sm">
                                Phóng to
                              </Button>
                              <Button onClick={() => onScale(scale - 0.2)} color="yellow" size="sm">
                                Thu nhỏ
                              </Button>
                              <Button
                                color="green"
                                size="sm"
                                onClick={() => downloadImage(objImageDetail.url, objImageDetail.id)}
                              >
                                Tải về
                              </Button>
                            </div>
                          )}
                        >
                          <div className="grid grid-cols-3 lg:grid-cols-5 gap-2 pb-2">
                            {row.anh_qhxd &&
                              row.anh_qhxd?.split(',').length > 0 &&
                              row.anh_qhxd?.split(',').map((imageSrc, i) => (
                                <figure className="relative w-full" key={i}>
                                  {typeImg(imageSrc) ? (
                                    <div className="bg-white border rounded-lg cursor-pointer">
                                      <PhotoView src={`${API_URL}/imgshop?name=${imageSrc}`}>
                                        <LazyLoadImage
                                          alt={'không có ảnh'}
                                          width={'100%'}
                                          effect="blur"
                                          src={`${API_URL}/imgshop?name=${imageSrc}`}
                                          className=" border hover:border-amber-500 hover:border-dashed p-1 rounded-2xl cursor-pointer"
                                          onClick={() => {
                                            setObjImageDetail({ id: i, url: `${API_URL}/imgshop?name=${imageSrc}` });
                                          }}
                                        />
                                      </PhotoView>
                                    </div>
                                  ) : (
                                    <div className="w-full h-full border rounded-xl flex justify-center items-center">
                                      <a
                                        href={`${API_URL}/imgshop?name=${imageSrc}`}
                                        download={imageSrc}
                                        className=" border hover:border-amber-500 hover:border-dashed p-1 rounded-xl"
                                      >
                                        {'file_' + (i + 1)}
                                      </a>
                                    </div>
                                  )}
                                  <figcaption className="absolute top-[5px] left-[29px] flex px-1 -translate-x-2/4 justify-center border border-white bg-white text-white shadow-lg shadow-black/5 saturate-200 backdrop-blur-sm rounded-lg">
                                    <div
                                      className="flex items-center cursor-pointer"
                                      onClick={() => downloadImage(`${API_URL}/imgshop?name=${imageSrc}`, i, 'taiso')}
                                    >
                                      <ArrowDownTrayIcon className="w-5 h-5 text-orange-600" />
                                      <span className="text-orange-600 text-xs ml-1"> #{i + 1}</span>
                                    </div>
                                  </figcaption>
                                </figure>
                              ))}
                          </div>
                        </PhotoProvider>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </DialogBody>
          </Dialog>
          {Object.keys(data).length > 0 && (
            <div className="grid grid-cols-5 gap-2 rounded-[40px] border-t-2 border-t-amber-500 p-4 items-center hover:bg-[#fffdf4]">
              <div>
                <LazyLoadImage
                  alt={'không có ảnh'}
                  width={'100%'}
                  effect="blur"
                  src={imageAvt}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = images.banner_login;
                  }}
                  className="rounded-3xl w-96"
                />
              </div>

              <div className="col-span-4 leading-7">
                <Link to={`/bds/${encode(data.id)}`} target="_blank">
                  <h2 className="text-base font-bold mb-1 cursor-pointer">{`${data.loaibds ? data?.loaibds : ''}${
                    data.loaivitri ? ' - ' + data?.loaivitri : ''
                  }${data.phaply ? ' - ' + data?.phaply : ''}${
                    data.duong
                      ? ' - đường ' +
                        data?.duong +
                        ', ' +
                        data?.xa +
                        (phuonggroup ? ` (${phuonggroup})` : '') +
                        ', ' +
                        data?.huyen
                      : ''
                  }${data.rongduong ? ', đường trước nhà ' + data?.rongduong + 'm' : ''}`}</h2>
                </Link>
                <p className=" font-sans">
                  {' '}
                  {/* {(data.sotang !== '0' ? (data?.sotang ? ' 👉 ' + data?.sotang + ' tầng' : '') : '') +
                (data.sotang !== '0'
                  ? (data?.ngang ? ' - ngang ' + data?.ngang + 'm' : '') +
                    (data?.nganghau ? `(ngang hậu ${data?.nganghau}m)` : '')
                  : data?.ngang
                  ? (data?.ngang ? ' 👉 ngang' + data?.ngang + 'm' : '') +
                    (data?.nganghau ? `(ngang hậu ${data?.nganghau}m)` : '')
                  : '') +
                (data.sophong !== '0' ? (data?.sophong ? ' - ' + data?.sophong + ' phòng' : '') : '') +
                (data.sowc ? ' - ' + data?.sowc + ' WC' : '') +
                (data.dientich && data.dai
                  ? ` - ${data.ngang ? data.ngang + 'm x' : ''} ${data.dai ? data.dai + 'm' : ''} - ${data.dientich}m2`
                  : `  ${data.dientich ? ' - DT ' + data.dientich + 'm2' : ''}`) +
                (data.dientichdatnn !== '0'
                  ? data?.dientichdatnn
                    ? ' - ' + data?.dientichdatnn + ' m2 đất nông nghiệp'
                    : ''
                  : '') +
                (data.dientichsan ? ' - tổng diện tích sàn ' + data?.dientichsan + 'm2' : '') +
                (data.huongbds ? ' - hướng ' + data?.huongbds : '') +
                (data.tiennghi ? ' - ' + data?.tiennghi : '') +
                (data.dactrung ? ' - ' + data?.dactrung : '') +
                (data.quyhoach ? ' - Quy hoạch ' + data?.quyhoach : '')} */}
                  {data?.dientich && data.dientichdatnn && data.dientichdatnn !== null && data.dientichdatnn !== '0'
                    ? '\n👉 Diện tích: ' +
                      keepTwoDecimals(parseFloat(data?.dientich) + parseFloat(data?.dientichdatnn)) +
                      'm2' +
                      ` (${data?.dientich && data?.dientich !== '0' ? data?.dientich + ' m2 thổ cư,' : ''}${
                        data?.dientichdatnn ? data?.dientichdatnn + ' m2 đất nông nghiệp' : ''
                      } )`
                    : ''}
                  {data?.dientich &&
                  (data.dientichdatnn === '0' || data.dientichdatnn === null || data.dientichdatnn === '')
                    ? '\n👉 Diện tích: ' + data?.dientich + 'm2' + (data?.ngang ? ', ngang ' + data?.ngang + 'm' : '')
                    : ''}
                </p>
                <p className=" font-sans">
                  {' '}
                  {data.sotang !== '0'
                    ? '👉 Kết cấu: ' +
                      (data?.sotang ? data?.sotang + ' tầng' : '') +
                      (data.sophong !== '0'
                        ? (data?.sophong ? ' - ' + data?.sophong + ' phòng' : '') +
                          (data.sowc ? ' - ' + data?.sowc + ' WC' : '')
                        : '')
                    : ''}
                </p>
                <p className=" font-sans"> {data?.quyhoach ? '👉 Quy hoạch: ' + data?.quyhoach : ''} </p>
                <p className=" font-sans">{data?.phaply ? '👉 Pháp lý: ' + data?.phaply : ''} </p>
                <p className=" font-sans">
                  {data?.huongbds && (
                    <>
                      {'👉 Hướng '}
                      {data.huongbds}

                      {(() => {
                        const huong = data.huongbds;

                        // Nếu đã có nhóm hoặc là Không Xác Định thì không thêm gì nữa
                        if (
                          huong.includes('Đông Tứ Trạch') ||
                          huong.includes('Tây Tứ Trạch') ||
                          huong.includes('Không Xác Định')
                        ) {
                          return '';
                        }

                        const arr = huong.split(',').map((i) => i.trim());

                        const dongTuTrach = ['Đông', 'Đông Nam', 'Nam', 'Bắc'];
                        const tayTuTrach = ['Tây', 'Tây Bắc', 'Tây Nam', 'Đông Bắc'];

                        if (arr.some((h) => dongTuTrach.includes(h))) {
                          return ', Đông Tứ Trạch';
                        }

                        if (arr.some((h) => tayTuTrach.includes(h))) {
                          return ', Tây Tứ Trạch';
                        }

                        return '';
                      })()}
                    </>
                  )}{' '}
                </p>

                {/* <p className=" font-sans">
                  {data?.dactrung || data?.tiennghi || data?.notekhach
                    ? '👉 Mô tả: ' +
                      (data?.tiennghi ? ' - ' + data?.tiennghi : '') +
                      (data?.dactrung ? ' - ' + data?.dactrung : '')
                    : ''}
                </p> */}
                <div className="flex items-center my-1 lg:px-5 font-sans">
                  <div className="flex items-center mr-2">
                    <UserIcon className="w-5 h-5 mr-1" />{' '}
                    <label className={`${isOldData(data?.is_user) ? 'text-gray-400' : ''}`}>
                      {isOldData(data?.is_user) ? 'Old Data' : data?.username}
                    </label>{' '}
                  </div>
                  <div className="flex items-center">
                    <ClockIcon className="w-5 h-5 mr-1" />{' '}
                    <label>
                      {data?.create_date?.split('T')[1]} - {data?.create_date?.split('T')[0]}
                    </label>{' '}
                  </div>
                </div>

                <div className="lg:flex lg:items-center">
                  {isBdsStatus(data.status, 2) ? (
                    <p className="font-bold text-red-700 font-sans ml-1">
                      Đã Bán -{' '}
                      {giaCmt > 0 ? convertNumberToWords(giaCmt) : convertNumberToWords(data?.gia ? data?.gia : '')}
                    </p>
                  ) : isBdsStatus(data.status, 5) ? (
                    <p className="font-bold text-red-700 font-sans ml-1">Ngưng bán</p>
                  ) : isBdsStatus(data.status, 6) ? (
                    <p className="font-bold text-red-700 font-sans ml-1">Không hề bán</p>
                  ) : (
                    <p className="font-bold text-green-700 font-sans ml-1">
                      {giaCmt > 0 ? convertNumberToWords(giaCmt) : convertNumberToWords(data?.gia ? data?.gia : '')}{' '}
                      {giaCmt > 0
                        ? data?.dientich
                          ? `- ${convertNumberToWords(
                              parseInt(giaCmt) / (parseInt(data?.dientich || 1) + parseInt(data?.dientichdatnn || 0)),
                            )}/m2`
                          : ''
                        : data?.gia && data?.dientich
                          ? `- ${convertNumberToWords(
                              parseInt(data?.gia) /
                                (parseInt(data?.dientich || 1) + parseInt(data?.dientichdatnn || 0)),
                            )}/m2`
                          : ''}
                      <span className="font-light text-gray-900">
                        {giaCmt > 0 && data?.gia
                          ? parseInt(data?.gia) > parseInt(giaCmt)
                            ? ` (đã giảm ${convertNumberToWords(parseInt(data?.gia) - parseInt(giaCmt))})`
                            : ` (đã tăng ${convertNumberToWords(parseInt(giaCmt) - parseInt(data?.gia))})`
                          : ''}{' '}
                      </span>
                      <br />
                      <span className="font-bold text-teal-800">
                        {' '}
                        {data?.giathue > 0 && 'Giá thuê: ' + convertNumberToWords(data?.giathue)}{' '}
                      </span>
                    </p>
                  )}
                  {discountCmt && <p className="font-bold text-green-700">| {discountCmt}</p>}
                  <Link
                    to={`/bang-gia-m2?lbs=${data?.loaibds}&lvt=${data?.loaivitri}&d=${data?.duong}&h=${data?.huyen}&gia=${data?.gia}&dt=${data?.dientich}`}
                    target="_blank"
                  >
                    <p className="text-blue-800 hover:underline hover:text-blue-500 cursor-pointer font-sans">
                      {data?.tlq?.totalRow > 0
                        ? ` - ${convertNumberToWords(parseInt(data?.tlq?.price) / parseInt(data?.tlq?.dt))}/m2 (${
                            data?.tlq?.totalRow
                          } bđs)`
                        : ''}
                    </p>
                  </Link>
                </div>
                <div>
                  {data?.notenoibo && (
                    <>
                      {' '}
                      <hr className="my-2 border-blue-gray-50" />
                      <SafeInline
                        className="text-black text-sm"
                        text={data?.notenoibo}
                        prefix="👉 Ghi chú (nội bộ): "
                      />
                    </>
                  )}
                </div>
                {data?.bl?.length > 0 && (
                  <div>
                    <hr className="my-2 border-blue-gray-50" />

                    {data?.bl?.map((row, i) => (
                      <p key={i} className={`flex items-center mb-2 pt-1 ${i !== 0 ? 'border-t' : ''}`}>
                        <span className="flex items-center text-sm">
                          <UserIcon className="w-4 h-4 mr-1" />
                          <label className={`${isOldData(row?.is_user) ? 'text-gray-400' : ''}`}>
                            {isOldData(row?.is_user) ? 'Old Data' : row?.username}
                          </label>
                          <ClockIcon className="w-4 h-4 ml-1 mr-1" /> {row?.update_date?.split('T')[1]} -{' '}
                          {row?.update_date?.split('T')[0]}:
                        </span>
                        <span className="ml-4 text-sm">
                          {row?.gia > 0
                            ? parseInt(data?.gia) > parseInt(row?.gia)
                              ? ` đã GIẢM ${convertNumberToWords(parseInt(data?.gia))} còn ${convertNumberToWords(
                                  row?.gia,
                                )}`
                              : ` đã TĂNG ${convertNumberToWords(parseInt(data?.gia))} lên ${convertNumberToWords(
                                  row?.gia,
                                )}`
                            : ''}
                          {row?.noidung ? ' - ' + row?.noidung : ''}
                          {row?.sdtchudat ? ' - đã thêm số chủ đất' : ''}
                          {row?.dientich ? ' - đã thêm diện tích thổ cư' : ''}
                          {row?.dientichdatnn ? ' - đã thêm diện tích nông nghiệp' : ''}
                          {row?.loaivitri ? ' - đã thêm loại vị trí' : ''}
                          {row?.loaibds ? ' - đã thêm loại bđs' : ''}
                          {row?.sotang ? ' - đã thêm số tầng' : ''}
                          {row?.sophong ? ' - đã thêm số phòng' : ''}
                          {row?.anh ? ' - đã thêm ảnh' : ''}
                          {row?.anhso ? ' - đã thêm ảnh sổ' : ''}
                          {row?.qhxd ? ' - Đã cập nhật quy hoạch XD ' : ''}
                          {row?.nhaclich
                            ? ' - đã nhắc nhở ' + new Date(row?.nhaclich).toLocaleDateString() + ' hết hạn bán'
                            : ''}
                        </span>
                      </p>
                    ))}
                  </div>
                )}

                <hr className="my-2 border-blue-gray-50" />
                <div className="flex items-end justify-end w-full">
                  <div
                    className="flex space-x-1 overflow-x-auto whitespace-nowrap w-full
    [scrollbar-width:thin] [scrollbar-color:#ff9800c2_#fde7c2]
    [&::-webkit-scrollbar]:h-1 
    [&::-webkit-scrollbar-thumb]:bg-gray-400 
    [&::-webkit-scrollbar-track]:bg-gray-200 pb-2"
                  >
                    <div>
                      <span className="mx-1">
                        {isHanche(data?.isdocquyen, 1) ? (
                          <b>Độc quyền</b>
                        ) : isHanche(data?.isdocquyen, 2) ? (
                          <b className="text-red-500">Hàng hot</b>
                        ) : (
                          ''
                        )}
                        {isHanche(data?.ishanche, 2) ? <b> - Hạn chế</b> : ''}
                      </span>
                      <span className="mx-1 flex lg:inline">
                        +{data?.create_date?.split('T')[1]} - {data?.create_date?.split('T')[0]}
                      </span>
                      <span className="mx-1">#{encode(data?.id)}</span>
                      <span
                        className="text-xs text-center bg-orange-400 rounded-md p-1 font-bold mx-1 cursor-pointer hover:bg-green-300"
                        onClick={() => {
                          handleOpen();
                          setIsSubModal(1);
                          historysUser({
                            id_bds: data?.id,
                            truong: 'xemhinh',
                            noidung: '1',
                          });
                          fetchIp();
                          fetchImages(showImages && showImages.join(','));
                        }}
                      >
                        Hình
                      </span>
                      {auth?.s4 == '0' && (
                        <span
                          className="text-xs text-center bg-orange-400 rounded-md p-1 font-bold mx-1 cursor-pointer hover:bg-green-300"
                          onClick={checkTotalSo}
                        >
                          Sổ
                        </span>
                      )}
                      <span
                        className={`${
                          isCopy === data?.id ? 'bg-green-400' : 'bg-orange-400'
                        } rounded-md p-1 whitespace-nowrap text-xs font-bold mx-1 cursor-pointer hover:bg-green-300`}
                        onClick={() => {
                          handleCopyText(data);
                        }}
                      >
                        {isCopy === data?.id ? 'Đã copy!' : 'Chia sẻ'}
                      </span>
                      {canViewPhone(auth, data, giaCmt) ? (
                        <span
                          className="text-xs text-center bg-orange-400 rounded-md p-1 font-bold mx-1 cursor-pointer hover:bg-green-300"
                          onClick={checkTotalSoChu}
                        >
                          SĐT
                        </span>
                      ) : (
                        ''
                      )}
                      <span
                        className="bg-orange-400 rounded-md p-1 whitespace-nowrap text-xs font-bold mx-1 cursor-pointer hover:bg-green-300"
                        onClick={() => {
                          handleOpen();
                          setIsSubModal(4);
                          historysUser({
                            id_bds: data?.id,
                            truong: 'xemchitiet',
                            noidung: '1',
                          });
                          fetchIp();
                        }}
                      >
                        Bình luận
                      </span>
                      <span
                        className={`${
                          data?.bl?.length > 0 && data?.bl?.some((item) => item.qhxd && item.qhxd.trim() !== '')
                            ? 'bg-orange-400 cursor-pointer hover:bg-green-300'
                            : 'bg-gray-400'
                        } rounded-md p-1 whitespace-nowrap text-xs font-bold mx-1 `}
                        onClick={() => {
                          if (data?.bl?.length > 0 && data?.bl?.find((item) => item.qhxd && item.qhxd.trim() !== '')) {
                            handleOpen();
                            setIsSubModal(7);
                          }
                        }}
                      >
                        Quy Hoạch XD
                      </span>
                      {auth?.username === 'admin' && (
                        <span
                          className="bg-red-600 text-white rounded-md p-1 whitespace-nowrap text-xs font-bold mx-1 cursor-pointer hover:bg-pink-600"
                          onClick={() => {
                            alertRemoveBV(data?.id);
                          }}
                        >
                          Xoá bài
                        </span>
                      )}
                    </div>
                    <div className="cursor-pointer">
                      {isYeuThich.some((item) => item.id === data.id) ? (
                        <HeartIcon className="w-5 h-5 text-pink-500" onClick={() => alertRemove(data?.id)} />
                      ) : (
                        <AB className="w-5 h-5" onClick={subAddDefault} />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default FrameShowBds;
